// extracted by mini-css-extract-plugin
export default {"wrapper":"SegmentedControl_wrapper__heZnC"};